/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./SocialTelegram.vue?vue&type=template&id=022b75ec&"
import script from "./SocialTelegram.vue?vue&type=script&lang=js&"
export * from "./SocialTelegram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports